import React from 'react';

import { AnalyticsContext, useAnalytics } from '@backstage/core-plugin-api';

interface AnalyticsWrapperProps {
  pluginId: string;
  children: React.ReactNode;
}

const AnalyticsEventTrigger = ({ contentGroup }: { contentGroup?: string }) => {
  const analytics = useAnalytics();

  React.useEffect(() => {
    analytics.captureEvent(
      'page_view',
      `${window.location.pathname}${window.location.search}`,
      {
        attributes: {
          ...(contentGroup && { content_group: contentGroup }),
        },
      },
    );
  }, [analytics, contentGroup]);

  return null;
};

export const AnalyticsWrapper: React.FC<AnalyticsWrapperProps> = ({
  pluginId,
  children,
}) => {
  return (
    <AnalyticsContext attributes={{ pluginId }}>
      <AnalyticsEventTrigger contentGroup={pluginId} />
      {children}
    </AnalyticsContext>
  );
};
